import { useState } from 'react';

let uid = 0;

/**
 * Provides getter for unique identifier. The identifier is stable for the whole life of its user component.
 * @param prefix
 */
const useGetUid = (prefix: string) =>
	useState(() => {
		let syntheticId = ``;
		// eslint-disable-next-line no-plusplus,no-return-assign
		return () => syntheticId || (syntheticId = `${prefix}_${uid++}`);
	})[0];

export default useGetUid;
